export const clusterColors = ['#EA3829', '#F68511', '#F8D904', '#AAD816', '#27BB36', '#008F5D', '#0FB5AE', '#3892F3', '#686DF4', '#893DE7', '#E055E2', '#DE3D82']
export const collaborationColors = ['#00b2eb', '#fd8010', '#f63d68', '#22ba5e', '#7b3aeb']

export const getRandomElement = list => list[Math.floor(Math.random() * list.length)]